import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { INFO } from "../data/site";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/menu", label: "Karte" },
  { to: "/story", label: "Story" },
  { to: "/events", label: "Events" },
  { to: "/kontakt", label: "Kontakt" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-base/90 backdrop-blur-md border-line" : "bg-transparent border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" className="font-display text-2xl sm:text-3xl uppercase tracking-tight leading-none" data-testid="logo-link">
          Banga<span className="text-harissa">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`font-mono text-xs uppercase tracking-[0.15em] relative group ${
                loc.pathname === l.to ? "text-harissa" : "text-ink"
              }`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-harissa transition-all duration-300 group-hover:w-full" />
            </Link>
          ))}
          <Link
            to="/reservierung"
            data-testid="nav-reserve-btn"
            className="font-mono text-xs uppercase tracking-[0.15em] bg-harissa text-base px-5 py-3 hover:bg-ink transition-colors duration-200"
          >
            Reservieren
          </Link>
        </nav>

        <button
          className="md:hidden text-ink"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-base border-t border-line"
            data-testid="mobile-menu"
          >
            <div className="px-5 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} className="font-head text-3xl uppercase" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              ))}
              <Link to="/reservierung" className="font-mono text-sm uppercase tracking-wider bg-harissa text-base px-5 py-4 text-center mt-2" data-testid="mobile-reserve-btn">
                Reservieren
              </Link>
              <p className="font-mono text-xs text-muted mt-2">{INFO.city} · {INFO.hours}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
